module.exports = __webpack_public_path__ + "img/bg07.ab341624.png";